import { PriceOverrideFormValues } from "./types";

export type PriceOverrideErrorField = keyof PriceOverrideFormValues;

export interface MappedPriceOverrideError {
  fieldErrors: Partial<Record<PriceOverrideErrorField, string>>;
  panelError: string | null;
  shouldRevealFxRate: boolean;
}

/** Maps the API's deliberately specific validation messages back onto the panel. */
export const mapPriceOverrideError = (
  messages: string[],
): MappedPriceOverrideError => {
  const fieldErrors: Partial<Record<PriceOverrideErrorField, string>> = {};
  const panelMessages: string[] = [];
  let shouldRevealFxRate = false;

  const assign = (field: PriceOverrideErrorField, message: string) => {
    if (!fieldErrors[field]) {
      fieldErrors[field] = message;
    }
  };

  for (const message of messages) {
    if (message.startsWith("An explicit fxToEur rate is required")) {
      assign("fxToEur", message);
      shouldRevealFxRate = true;
    } else if (
      message.includes("cannot be in the future") ||
      message.includes("valid YYYY-MM-DD") ||
      message.startsWith("Date ") ||
      message.startsWith("Price date ")
    ) {
      assign("date", message);
    } else if (
      message.startsWith("priceNative") ||
      message.startsWith("Price ") ||
      message.includes("Price is too large")
    ) {
      assign("priceNative", message);
    } else if (
      message.startsWith("fxToEur") ||
      message.startsWith("FX rate ")
    ) {
      assign("fxToEur", message);
      shouldRevealFxRate = true;
    } else {
      // Everything else — a missing instrument, a missing override, the rate limit, or a message
      // this panel has never seen — belongs to the form as a whole, not to one of its fields.
      panelMessages.push(message);
    }
  }

  return {
    fieldErrors,
    panelError: panelMessages.length > 0 ? panelMessages.join(" ") : null,
    shouldRevealFxRate,
  };
};
